import ElmCarousel from "../elm_carousel"
import { loadBackgroundImages, loadPictureTags }  from "../../helpers/image_loader"

declare global {
  interface Window {
    elmCarouselFlags : Flags
  }
}

const GALLERY_SELECTOR = "#js-hero-modal"
const IMAGE_SELECTOR = `${GALLERY_SELECTOR} .js-img`
const THUMBNAIL_SELECTOR = `${GALLERY_SELECTOR} .carousel-thumbnails [data-img]`

const setupHero = (carousel : ElmCarousel) : void => {
  const hero = document.getElementById("js-hero")
  if (!hero) return

  let slideIndex = 0

  hero.addEventListener("click", (e : Event) => {
    const target = e.target as HTMLElement
    const navigation = target?.closest("[data-slide-to]") as HTMLElement

    if (target?.closest("a")) e.stopImmediatePropagation()
    slideIndex = parseInt(navigation?.dataset.slideTo || "0", 10)
  })

  document.addEventListener("hero-modal:open", () => {
    carousel.ports.slideTo.send(slideIndex)
    carousel.ports.focus.send(null)
  })
}

export default () : void => {
  const node = document.getElementById("elm-carousel")
  if (!node) return

  const carousel = new ElmCarousel({
    node,
    flags: window.elmCarouselFlags,
    ports: {
      carouselActivated: () : void => {
        window.requestAnimationFrame(() =>
          loadPictureTags(document.querySelectorAll(IMAGE_SELECTOR))
        )
      },
      ready: () : void => {
        loadPictureTags(document.querySelectorAll(IMAGE_SELECTOR))
        loadBackgroundImages(document.querySelectorAll(THUMBNAIL_SELECTOR))
      }
    }
  })

  setupHero(carousel)
}
